export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/CarDealer.802ac35a.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};